import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import {
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_1,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { TableRenderer_getInstance1laavxqxr29w3 as TableRenderer_getInstance } from './TableRenderer.mjs';
import { FormSize383y0pj5845uy as FormSize } from './helpers.mjs';
import {
  ClassValue2g3gvkd2w780o as ClassValue,
  get_serializableAnnotations9pir9fao2oo as get_serializableAnnotations,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import {
  FormTypeInfo22ea2b5qphu87 as FormTypeInfo,
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  defaultColumns2bko8gwvd6xmb as defaultColumns,
  form1pdmcqj387954 as form,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_expanding10cuv3ua9vajx as get_expanding } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  gravity24js74359tyjo as gravity,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  onlyWhen1gzwe00zqrj87 as onlyWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { loadwmtw2477i8f8 as load } from '../../../../../kiteui-library/com/lightningkite/kiteui/lightweightSuspension.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Always_getInstancecs10mhg5aot2 as Always_getInstance,
  RawStringContains2aah1oj1an1a9 as RawStringContains,
  Conditionuclxcm24fzd9 as Condition,
  StringContains38lplog8dg7er as StringContains,
  Or3lq77uaxl3wr0 as Or,
  And3abx79zpqd7r8 as And,
  FullTextSearch2rlpx79w2gy53 as FullTextSearch,
  Companion_instancek13g6rikuawd as Companion_instance_1,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { debounce3uffs71hj1o26 as debounce } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  split3d3yeauc4rm2n as split,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { nullElementzitp7se36veh as nullElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  DataClassPath3joljqmfaqhxf as DataClassPath,
  DataClassPathNotNullyxwowc5mmyv5 as DataClassPathNotNull,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { Companion_getInstancejecdfbtr9cdw as Companion_getInstance_3 } from '../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { SortPartSerializer1fx0t5bmnpc8h as SortPartSerializer } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPartSerializer.mjs';
import { ListSerializer1hxuk9dx5n9du as ListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp0 = $this.xdu_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ydu_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_1 = $this.zdu_1.ddv_1(tmp0_safe_receiver, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp1_elvis_lhs = tmp_0;
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = tmp1_elvis_lhs == null ? 'None' : tmp1_elvis_lhs;
  var tmp_2 = tmp0.tb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = value;
  }
  tmp_2.fbu(tmp_3);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.edv_1.gah(null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  var tmp = $this.fdv_1.gah(it.h40(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closePopovers($this.gdv_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = $this.hdv_1.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('...') === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = '...';
  }
  tmp.fbu(tmp_0);
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$2 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
  var tmp_1 = delay(tmp$ret$2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0 = $this.hdv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jdv_1;
  var tmp_2 = await_0(this_0, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$3 = tmp_2;
  var tmp_3 = $this.idv_1.ddv_1(tmp$ret$3.h40(), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = tmp_3;
  var tmp_4 = tmp0.tb5_1;
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_5 = '\xA0';
  } else {
    tmp_5 = value;
  }
  tmp_4.fbu(tmp_5);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ldv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.kdv_1.gah(tmp$ret$0.h40(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  closePopovers($this.mdv_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp0 = $this.ndv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.odv_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_1 = $this.pdv_1.ddv_1(tmp0_safe_receiver, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  }
  var tmp1_elvis_lhs = tmp_0;
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = tmp1_elvis_lhs == null ? 'None' : tmp1_elvis_lhs;
  var tmp_2 = tmp0.tb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = value;
  }
  tmp_2.fbu(tmp_3);
  return Unit_instance;
}
var ForeignKeyRenderer$form$lambda$slambdaClass;
function ForeignKeyRenderer$form$lambda$slambda() {
  if (ForeignKeyRenderer$form$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$text, $mutable, $typeInfo) {
        this.xdu_1 = $$this$text;
        this.ydu_1 = $mutable;
        this.zdu_1 = $typeInfo;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ForeignKeyRenderer$form$lambda$slambdaClass = $;
  }
  return ForeignKeyRenderer$form$lambda$slambdaClass;
}
function ForeignKeyRenderer$form$lambda$slambda_0($$this$text, $mutable, $typeInfo) {
  var i = new (ForeignKeyRenderer$form$lambda$slambda())($$this$text, $mutable, $typeInfo);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ForeignKeyRenderer$form$lambda$lambda$slambdaClass;
function ForeignKeyRenderer$form$lambda$lambda$slambda() {
  if (ForeignKeyRenderer$form$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable) {
        this.edv_1 = $mutable;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ForeignKeyRenderer$form$lambda$lambda$slambdaClass = $;
  }
  return ForeignKeyRenderer$form$lambda$lambda$slambdaClass;
}
function ForeignKeyRenderer$form$lambda$lambda$slambda_0($mutable) {
  var i = new (ForeignKeyRenderer$form$lambda$lambda$slambda())($mutable);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambdaClass;
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambda() {
  if (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, $$this$swapping) {
        this.fdv_1 = $mutable;
        this.gdv_1 = $$this$swapping;
      }
      qdv(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.qdv((!(p1 == null) ? isInterface(p1, HasId()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambdaClass = $;
  }
  return ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambdaClass;
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambda_0($mutable, $$this$swapping) {
  var i = new (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambda())($mutable, $$this$swapping);
  var l = (it, $completion) => i.qdv(it, $completion);
  l.$arity = 1;
  return l;
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda(it) {
  return it.h40();
}
var ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass;
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda() {
  if (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$text, $typeInfo, $it) {
        this.hdv_1 = $$this$text;
        this.idv_1 = $typeInfo;
        this.jdv_1 = $it;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass = $;
  }
  return ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass;
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_0($$this$text, $typeInfo, $it) {
  var i = new (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda())($$this$text, $typeInfo, $it);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass_0;
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_1() {
  if (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($mutable, $it, $$this$button) {
        this.kdv_1 = $mutable;
        this.ldv_1 = $it;
        this.mdv_1 = $$this$button;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass_0 = $;
  }
  return ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambdaClass_0;
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_2($mutable, $it, $$this$button) {
  var i = new (ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_1())($mutable, $it, $$this$button);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$lambda($next, $module, $itemsMeta, $items, $mutable, $typeInfo) {
  return ($this$swap) => {
    var destruct = $next;
    var full = destruct.cf();
    var cache = destruct.df();
    var tmp;
    if (full) {
      var tmp0_$this = TableRenderer_getInstance();
      var tmp1_innerSer = cache.sdv_1;
      tmp = tmp0_$this.idw($this$swap, $module, tmp1_innerSer, $itemsMeta, VOID, null, ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$slambda_0($mutable, $this$swap));
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
      // Inline function 'kotlin.apply' call
      var this_0 = new (Recycler2())($this$swap, true);
      var tmp_0 = ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda;
      children(this_0, $items, tmp_0, ($this$children, it) => {
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp = $this$children.hbb(CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())($this$children.pc());
        var tmp0_elvis_lhs = $this$children.cbb_1;
        var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
        $this$children.ebb(p, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_0 = view_0.tb5_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('...') === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = '...';
        }
        tmp_0.fbu(tmp_1);
        // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
        var action = ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_0(view_0, $typeInfo, it);
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveContextSuspending())(view_0, VOID, VOID, action);
        this_0.yai();
        var tmp0_safe_receiver = view_0.ea2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cah(this_0);
        }
        view.fbb(p_0, view_0);
        var tmp_2 = Companion_getInstance_0().vcf_1;
        view.mbg(Action('Select', tmp_2, VOID, VOID, VOID, VOID, ForeignKeyRenderer$form$lambda$lambda$lambda$lambda$lambda$slambda_2($mutable, it, view)));
        $this$children.fbb(p, view);
        return $this$children.jbb(tmp, view);
      });
      tmp = this_0;
    }
    return tmp;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp_0(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x_0(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
var ForeignKeyRenderer$view$lambda$slambdaClass;
function ForeignKeyRenderer$view$lambda$slambda() {
  if (ForeignKeyRenderer$view$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$text, $readable, $typeInfo) {
        this.ndv_1 = $$this$text;
        this.odv_1 = $readable;
        this.pdv_1 = $typeInfo;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ForeignKeyRenderer$view$lambda$slambdaClass = $;
  }
  return ForeignKeyRenderer$view$lambda$slambdaClass;
}
function ForeignKeyRenderer$view$lambda$slambda_0($$this$text, $readable, $typeInfo) {
  var i = new (ForeignKeyRenderer$view$lambda$slambda())($$this$text, $readable, $typeInfo);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ForeignKeyRendererClass;
function ForeignKeyRenderer() {
  if (ForeignKeyRendererClass === VOID) {
    class $ {
      constructor() {
        this.jdw_1 = 'Foreign Key';
      }
      k20() {
        return this.jdw_1;
      }
      qdu() {
        return 'com.lightningkite.lightningdb.References';
      }
      cdu() {
        return 2.0;
      }
      idu(module_0, selector) {
        return new (FormSize())(16.0, 1.0);
      }
      ddu(module_0, selector) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = selector.fdu_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l4s_1 === 'com.lightningkite.lightningdb.References' || element.l4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4s_1;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var anno = tmp;
        var tmp2_safe_receiver = anno.p3('references');
        var tmp_0;
        if (tmp2_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = tmp2_safe_receiver instanceof ClassValue() ? tmp2_safe_receiver : null;
        }
        var tmp3_safe_receiver = tmp_0;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.d4w_1;
        var tmp_1;
        if (tmp4_elvis_lhs == null) {
          return false;
        } else {
          tmp_1 = tmp4_elvis_lhs;
        }
        var typeName = tmp_1;
        var tmp_2 = module_0.kdt_1(typeName);
        var tmp5_elvis_lhs = tmp_2 instanceof FormTypeInfo() ? tmp_2 : null;
        var tmp_3;
        if (tmp5_elvis_lhs == null) {
          return false;
        } else {
          tmp_3 = tmp5_elvis_lhs;
        }
        var typeInfo = tmp_3;
        return true;
      }
      ldu(module_0, selector) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = selector.fdu_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l4s_1 === 'com.lightningkite.lightningdb.References' || element.l4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp$ret$2 = tmp$ret$1;
        var anno = ensureNotNull(tmp$ret$2).m4s_1;
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(anno.p3('references'));
        var typeName = (it instanceof ClassValue() ? it : THROW_CCE()).d4w_1;
        var tmp = ensureNotNull(module_0.kdt_1(typeName));
        var typeInfo = tmp instanceof FormTypeInfo() ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.ebb(p, view);
          view.xbm(false);
          view.zb8(get_px(0));
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (MenuButton())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          var $this$menuButton = view_0;
          $this$menuButton.yc3_1 = true;
          var tmp_1 = gravity($this$menuButton, Align_Start_getInstance(), Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())($this$menuButton.pc());
          var tmp0_elvis_lhs_1 = $this$menuButton.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? $this$menuButton : tmp0_elvis_lhs_1;
          $this$menuButton.ebb(p_1, view_1);
          // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
          var action = ForeignKeyRenderer$form$lambda$slambda_0(view_1, mutable, typeInfo);
          // Inline function 'kotlin.also' call
          var this_0 = new (ReactiveContextSuspending())(view_1, VOID, VOID, action);
          this_0.yai();
          var tmp0_safe_receiver = view_1.ea2().cd(Key_instance);
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cah(this_0);
          }
          $this$menuButton.fbb(p_1, view_1);
          $this$menuButton.jbb(tmp_1, view_1);
          $this$menuButton.ec4(($this$opensMenu) => {
            var tmp;
            if (selector.edu_1.az().l11()) {
              load($this$opensMenu, VOID, ForeignKeyRenderer$form$lambda$lambda$slambda_0(mutable));
              tmp = Unit_instance;
            }
            $this$menuButton.bc4(Companion_getInstance_1().ycq_1);
            var full = Signal().fak(false);
            var tmp_0 = sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, get_rem(25), get_rem(25));
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())($this$opensMenu.pc());
            var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
            $this$opensMenu.ebb(p, view);
            view.xbm(true);
            var textSearch = Signal().fak('');
            var condition = Signal().fak(Always_getInstance());
            // Inline function 'kotlin.collections.listOf' call
            var tmp$ret$12 = emptyList();
            var sort = Signal().fak(tmp$ret$12);
            var tmp0 = get_serializableAnnotations(typeInfo.adv_1);
            var tmp$ret$13;
            $l$block_1: {
              // Inline function 'kotlin.collections.any' call
              var tmp_1;
              if (isInterface(tmp0, Collection())) {
                tmp_1 = tmp0.i1();
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp$ret$13 = false;
                break $l$block_1;
              }
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (endsWith(element.l4s_1, 'TextIndex')) {
                  tmp$ret$13 = true;
                  break $l$block_1;
                }
              }
              tmp$ret$13 = false;
            }
            var hasTextIndex = tmp$ret$13;
            // Inline function 'kotlin.run' call
            var tmp$ret$16 = defaultColumns(typeInfo.adv_1);
            var columns = Signal().fak(tmp$ret$16);
            var itemsMeta = remember(VOID, VOID, VOID, ($this$remember) => {
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              var tmp = typeInfo.bdv_1($this$remember);
              // Inline function 'kotlin.takeUnless' call
              var this_0 = $this$remember.baj(debounce(textSearch, 500n));
              var tmp_0;
              if (!isBlank(this_0)) {
                tmp_0 = this_0;
              } else {
                tmp_0 = null;
              }
              var tmp0_safe_receiver = tmp_0;
              var tmp_1;
              if (tmp0_safe_receiver == null) {
                tmp_1 = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_2;
                if (hasTextIndex) {
                  tmp_2 = FullTextSearch().z3r(tmp0_safe_receiver);
                } else {
                  // Inline function 'kotlin.collections.map' call
                  var this_1 = split(tmp0_safe_receiver, charArrayOf([_Char___init__impl__6a9atx(32)]));
                  // Inline function 'kotlin.collections.mapTo' call
                  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
                  var _iterator__ex2g4s = this_1.m1();
                  while (_iterator__ex2g4s.n1()) {
                    var item = _iterator__ex2g4s.o1();
                    // Inline function 'kotlin.collections.mapNotNull' call
                    var tmp0 = $this$remember.baj(columns);
                    // Inline function 'kotlin.collections.mapNotNullTo' call
                    var destination_0 = ArrayList().w();
                    // Inline function 'kotlin.collections.forEach' call
                    var _iterator__ex2g4s_0 = tmp0.m1();
                    while (_iterator__ex2g4s_0.n1()) {
                      var element = _iterator__ex2g4s_0.o1();
                      // Inline function 'kotlin.let' call
                      var it = element.j2j();
                      var tmp0_elvis_lhs = nullElement(it);
                      var tmp$ret$21 = tmp0_elvis_lhs == null ? it : tmp0_elvis_lhs;
                      var s = substringBefore(tmp$ret$21.az().h10(), _Char___init__impl__6a9atx(47));
                      var tmp_3;
                      if (element.j2j().az().l11()) {
                        tmp_3 = new (DataClassPathNotNull())(element instanceof DataClassPath() ? element : THROW_CCE());
                      } else {
                        tmp_3 = element;
                      }
                      var p = tmp_3;
                      var tmp_4;
                      if (s === 'kotlin.String') {
                        var tmp_5 = StringContains().u3r(item, true);
                        tmp_4 = p.m3t(tmp_5 instanceof Condition() ? tmp_5 : THROW_CCE());
                      } else if (Companion_getInstance_3().i3n_1.t1(s)) {
                        var tmp_6 = RawStringContains().w3r(item, true);
                        tmp_4 = p.m3t(tmp_6 instanceof Condition() ? tmp_6 : THROW_CCE());
                      } else {
                        tmp_4 = null;
                      }
                      var tmp0_safe_receiver_0 = tmp_4;
                      if (tmp0_safe_receiver_0 == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        destination_0.v(tmp0_safe_receiver_0);
                      }
                    }
                    // Inline function 'kotlin.takeUnless' call
                    var tmp_7;
                    if (!destination_0.i1()) {
                      tmp_7 = destination_0;
                    } else {
                      tmp_7 = null;
                    }
                    var tmp0_safe_receiver_1 = tmp_7;
                    var tmp_8;
                    if (tmp0_safe_receiver_1 == null) {
                      tmp_8 = null;
                    } else {
                      // Inline function 'kotlin.let' call
                      tmp_8 = Or().z3q(tmp0_safe_receiver_1);
                    }
                    var tmp1_elvis_lhs = tmp_8;
                    var tmp$ret$33 = tmp1_elvis_lhs == null ? Always_getInstance() : tmp1_elvis_lhs;
                    destination.v(tmp$ret$33);
                  }
                  // Inline function 'kotlin.let' call
                  tmp_2 = And().w3q(destination);
                }
                tmp_1 = tmp_2;
              }
              return tmp.kdw(new (Query())(And().w3q(listOfNotNull([tmp_1, $this$remember.baj(debounce(condition, 500n))])), $this$remember.baj(debounce(sort, 500n))));
            });
            var items = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(itemsMeta)));
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (RowOrCol())(view.pc());
            var tmp0_elvis_lhs_0 = view.cbb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.ebb(p_0, view_0);
            view_0.xbm(false);
            var tmp_2 = get_expanding(view_0);
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp$ret$40 = view_0.hbb(FieldSemantic_getInstance());
            var tmp_3 = view_0.ibb(tmp_2, tmp$ret$40);
            // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_1 = new (TextInput())(view_0.pc());
            var tmp0_elvis_lhs_1 = view_0.cbb_1;
            var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
            view_0.ebb(p_1, view_1);
            view_1.xah(view_1.gcn_1, textSearch);
            view_0.fbb(p_1, view_1);
            view_0.jbb(tmp_3, view_1);
            var tmp_4 = onlyWhen(view_0, VOID, ($this$onlyWhen) => $this$onlyWhen.baj(full));
            // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_2 = new (MenuButton())(view_0.pc());
            var tmp0_elvis_lhs_2 = view_0.cbb_1;
            var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
            view_0.ebb(p_2, view_2);
            dynamicTheme(view_2, ($this$dynamicTheme) => !$this$dynamicTheme.baj(condition).equals(Always_getInstance()) ? SelectedSemantic_getInstance() : null);
            icon(view_2, Companion_getInstance_0().lcg_1, 'Filter');
            view_2.yc3_1 = true;
            view_2.ec4(($this$opensMenu) => {
              form($this$opensMenu, module_0, Companion_instance_1.d2j(typeInfo.adv_1), condition);
              return Unit_instance;
            });
            view_0.fbb(p_2, view_2);
            view_0.jbb(tmp_4, view_2);
            var tmp_5 = onlyWhen(view_0, VOID, ($this$onlyWhen) => $this$onlyWhen.baj(full));
            // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (MenuButton())(view_0.pc());
            var tmp0_elvis_lhs_3 = view_0.cbb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
            view_0.ebb(p_3, view_3);
            dynamicTheme(view_3, ($this$dynamicTheme) => {
              var tmp;
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!$this$dynamicTheme.baj(sort).i1()) {
                tmp = SelectedSemantic_getInstance();
              } else {
                tmp = null;
              }
              return tmp;
            });
            icon(view_3, Companion_getInstance_0().kcg_1, 'Sort');
            view_3.yc3_1 = true;
            view_3.ec4(($this$opensMenu) => {
              form($this$opensMenu, module_0, ListSerializer(new (SortPartSerializer())(typeInfo.adv_1)), sort);
              return Unit_instance;
            });
            view_0.fbb(p_3, view_3);
            view_0.jbb(tmp_5, view_3);
            // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (ToggleButton())(view_0.pc());
            var tmp0_elvis_lhs_4 = view_0.cbb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
            view_0.ebb(p_4, view_4);
            view_4.xah(view_4.ncq_1, full);
            icon(view_4, Companion_getInstance_0().ecg_1, 'Show More');
            view_0.fbb(p_4, view_4);
            view.fbb(p_0, view_0);
            var tmp_6 = get_expanding(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_5 = new (SwapView())(view.pc());
            var tmp0_elvis_lhs_5 = view.cbb_1;
            var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
            view.ebb(p_5, view_5);
            // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
            var this_0 = view_5;
            var queue = ArrayList().w();
            var alreadySwapping = {_v: false};
            reactiveScope(this_0, ($this$reactiveScope) => {
              var tmp = $this$reactiveScope.baj(full);
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              var tmp$ret$58 = typeInfo.bdv_1($this$reactiveScope);
              var c = to(tmp, tmp$ret$58);
              queue.v(c);
              var tmp_0;
              if (alreadySwapping._v) {
                return Unit_instance;
              }
              alreadySwapping._v = true;
              $l$loop: while (true) {
                // Inline function 'kotlin.collections.isNotEmpty' call
                if (!!queue.i1()) {
                  break $l$loop;
                }
                var next = queue.z3(0);
                try {
                  var tmp_1 = Companion_getInstance_2().vax_1;
                  this_0.rci(tmp_1, ForeignKeyRenderer$form$lambda$lambda$lambda$lambda(next, module_0, itemsMeta, items, mutable, typeInfo));
                } catch ($p) {
                  if ($p instanceof Exception()) {
                    var e = $p;
                    report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
                  } else {
                    throw $p;
                  }
                }
              }
              alreadySwapping._v = false;
              return Unit_instance;
            });
            view.fbb(p_5, view_5);
            view.jbb(tmp_6, view_5);
            $this$opensMenu.fbb(p, view);
            $this$opensMenu.jbb(tmp_0, view);
            return Unit_instance;
          });
          view.fbb(p_0, view_0);
          view.jbb(tmp_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Link())(view.pc());
          var tmp0_elvis_lhs_2 = view.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.ebb(p_2, view_2);
          icon(view_2, Companion_getInstance_0().cch_1.gd5(get_rem(1), get_rem(1)), 'Open');
          var tmp_2 = KMutableProperty0();
          var tmp_3 = Link$_get_to_$ref_jq7esp(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, Link$_set_to_$ref_i9gu5x(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var tmp$ret$73;
            $l$block_2: {
              var tmp0_elvis_lhs = $this$reactiveScope.baj(mutable);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                tmp$ret$73 = null;
                break $l$block_2;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var id = tmp;
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              tmp$ret$73 = typeInfo.cdv_1($this$reactiveScope, id);
            }
            this_1.set(tmp$ret$73);
            return Unit_instance;
          });
          view.fbb(p_2, view_2);
          $this$FormRenderer.fbb(p, view);
          return $this$FormRenderer.jbb(tmp, view);
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      ndu(module_0, selector) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = selector.fdu_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l4s_1 === 'com.lightningkite.lightningdb.References' || element.l4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp$ret$2 = tmp$ret$1;
        var anno = ensureNotNull(tmp$ret$2).m4s_1;
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(anno.p3('references'));
        var typeName = (it instanceof ClassValue() ? it : THROW_CCE()).d4w_1;
        var tmp = ensureNotNull(module_0.kdt_1(typeName));
        var typeInfo = tmp instanceof FormTypeInfo() ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, field, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Link())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.ebb(p, view);
          var tmp = KMutableProperty0();
          var tmp_0 = Link$_get_to_$ref_jq7esp_0(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x_0(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$5;
            $l$block_0: {
              var tmp0_elvis_lhs = $this$reactiveScope.baj(readable);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                tmp$ret$5 = null;
                break $l$block_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var id = tmp;
              // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
              tmp$ret$5 = typeInfo.cdv_1($this$reactiveScope, id);
            }
            this_0.set(tmp$ret$5);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          // Inline function 'com.lightningkite.reactive.context.reactiveSuspending' call
          var action = ForeignKeyRenderer$view$lambda$slambda_0(view_0, readable, typeInfo);
          // Inline function 'kotlin.also' call
          var this_1 = new (ReactiveContextSuspending())(view_0, VOID, VOID, action);
          this_1.yai();
          var tmp0_safe_receiver = view_0.ea2().cd(Key_instance);
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cah(this_1);
          }
          view.fbb(p_0, view_0);
          $this$ViewRenderer.fbb(p, view);
          return view;
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'ForeignKeyRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ForeignKeyRendererClass = $;
  }
  return ForeignKeyRendererClass;
}
var ForeignKeyRenderer_instance;
function ForeignKeyRenderer_getInstance() {
  return ForeignKeyRenderer_instance;
}
//region block: init
ForeignKeyRenderer_instance = new (ForeignKeyRenderer())();
//endregion
//region block: exports
export {
  ForeignKeyRenderer_instance as ForeignKeyRenderer_instance2lj28oaf1gant,
};
//endregion

//# sourceMappingURL=ForeignKeyRenderer.mjs.map
